<template>
  <section class="relative hero-section overflow-hidden">
    <!-- Background hero image (single, no carousel) -->
    <div class="absolute inset-0 h-full z-0 pointer-events-none">
      <picture>
        <source
          media="(orientation: portrait) and (aspect-ratio: 10/16)"
          :srcset="heroBgPortrait"
        />
        <source
          media="(orientation: landscape) and (aspect-ratio: 16/10)"
          :srcset="heroBgLandscape"
        />
        <img
          :src="backgroundSrc"
          alt="Hero About - Kali Sistemas"
          class="hero-bg select-none absolute inset-0"
        />
      </picture>
    </div>

    <!-- Content -->
    <div class="relative z-10 h-full flex items-center">
      <main class="mt-0 mx-auto w-full max-w-[1440px] px-6">
        <div
          class="grid grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-12 items-center h-full w-full"
        >
          <!-- Left Content (same text as Home hero) -->
          <div class="text-left text-white drop-shadow-md justify-self-start">
            <div class="relative animate-fadeIn">
              <h1
                class="text-4xl sm:text-5xl md:text-6xl font-black tracking-normal leading-[1.15] md:leading-[1.2] text-shadow-hero"
              >
                <span class="block">Conheça nossa</span>
                <span class="block">trajetória</span>
              </h1>
            </div>

            <p
              class="mt-4 text-lg sm:text-xl text-white/90 leading-relaxed animate-fadeIn delay-200 text-shadow-hero-sm"
            >
              <span class="md:block"
                >Conheça a história, missão e cultura da Kali Sistemas.</span
              >
              <span class="md:block"
                >Com a Kali Sistemas, você simplifica a gestão e impulsiona
                resultados.</span
              >
              <span class="md:block"
                >Parceria, confiança e evolução contínua definem quem
                somos.</span
              >
            </p>

            <div
              v-if="showCtas"
              class="mt-8 flex flex-col sm:flex-row gap-4 animate-fadeIn delay-300"
            >
              <button
                type="button"
                @click="openScheduleDemo"
                class="group relative inline-flex items-center justify-center px-8 py-3 text-lg font-medium rounded-xl text-[#004d6b] bg-white/90 hover:bg:white transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl pointer-events-auto"
              >
                <span class="relative flex items-center">
                  Agendar Demo
                  <svg
                    class="ml-2 -mr-1 w-5 h-5 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </span>
              </button>

              <RouterLink
                to="/solucao/kali-gestao"
                class="group inline-flex items-center justify-center px-8 py-3 text-lg font-medium rounded-xl text-[#006086] bg-white hover:bg-[#e6f0f4] border-2 border-[#cce0eb] hover:border-[#b3d1e0] transform hover:scale-105 transition-all duration-200 shadow-md hover:shadow-lg pointer-events-auto"
              >
                <span class="relative flex items-center">
                  Nossas Soluções
                  <svg
                    class="ml-2 -mr-1 w-5 h-5 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    ></path>
                  </svg>
                </span>
              </RouterLink>
            </div>
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: "AboutHeroSection" });
import { RouterLink } from "vue-router";
import { computed } from "vue";
import heroSobreNos from "@/assets/hero-sobrenos.webp";

const props = defineProps({
  background: { type: String, default: "" },
  showCtas: { type: Boolean, default: false },
});

const backgroundSrc = computed(() => {
  if (!props.background) return heroSobreNos;
  return props.background;
});

const heroBgPortrait = heroSobreNos;
const heroBgLandscape = heroSobreNos;

const openScheduleDemo = () => {
  window.dispatchEvent(new CustomEvent("open-demo-modal"));
};
</script>

<style scoped>
/* Hero full viewport */
.hero-section {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  margin: 0;
  padding: 0;
}

.hero-bg {
  width: 100%;
  height: 100%;
  object-fit: cover; /* preenche sem distorção */
  object-position: right center; /* prioriza o lado direito da foto (onde está a equipe) */
}
/* Text shadows to improve contrast over light images */
.text-shadow-hero {
  text-shadow:
    0 2px 10px rgba(0, 0, 0, 0.65),
    0 1px 2px rgba(0, 0, 0, 0.55);
}
.text-shadow-hero-sm {
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);
}

/* Galaxy Tab S11: comum proporção 16:10; cobrimos retrato e paisagem */
@media (orientation: portrait) and (aspect-ratio: 10/16) {
  .hero-section {
    width: 100%;
    height: 100vh;
  }
  .hero-bg {
    object-position: right center;
  }
}

@media (orientation: landscape) and (aspect-ratio: 16/10) {
  .hero-section {
    width: 100%;
    height: 100vh;
  }
  .hero-bg {
    object-position: right center;
  }
}
</style>
